module.exports = __webpack_public_path__ + "img/c22c422.jpg";